const baseAuthConfig = {
  redirectUri: `${window.location.origin}${window.location.pathname}`, // widget auth callback url
  redirectUriIframe: `${window.location.origin}/hula/auth_callback.html`,
  useRefreshTokens: true,
}

const devAuthConfig = {
  ...baseAuthConfig,
  clientId: 'dhbwAGGEM9K655euvO84QdZtWHSA5Ghg',
  env: 'stg',
}

const stgAuthConfig = {
  ...baseAuthConfig,
  clientId: 'dhbwAGGEM9K655euvO84QdZtWHSA5Ghg',
  env: 'stg',
}

const prdAuthConfig = {
  ...baseAuthConfig,
  clientId: '7LJG9Rv9FLuxuVe7MBAIxW8zmYPTHt0d',
  env: 'prod',
}

const authConfigs = {
  dev: devAuthConfig,
  stg: stgAuthConfig,
  prd: prdAuthConfig,
}

const authConfig = authConfigs[process.env.REACT_APP_TIER || 'prd']

export default authConfig
